<script setup lang="ts">
import { useTheme } from 'vuetify'
import { useThemeConfig } from '@core/composable/useThemeConfig'
import { hexToRgb } from '@layouts/utils'
import { useSnackbarStore } from '@/store/snackbar'
import { useRouter } from 'vue-router'

const { syncInitialLoaderTheme, syncVuetifyThemeWithTheme: syncConfigThemeWithVuetifyTheme } = useThemeConfig()

const { global } = useTheme()
const router = useRouter()
const snackbarStore = useSnackbarStore()

// ℹ️ Sync current theme with initial loader theme
syncInitialLoaderTheme()
syncConfigThemeWithVuetifyTheme()

// Close Snackbar on ANY click
const handleGlobalClick = () => {
  if (!snackbarStore.showSnackbar) return

  // Ignore the same click that opened the snackbar
  if (Date.now() - snackbarStore.openedAt < 100) return

  snackbarStore.closeMessage()
}

onMounted(() => {
  document.addEventListener('click', handleGlobalClick)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', handleGlobalClick)
})

// Close Snackbar on route change
router.beforeEach(() => {
  snackbarStore.closeMessage()
})
</script>

<template>
  <VLocaleProvider>
    <!-- ℹ️ This is required to set the background color of active nav link based on currently active global theme's primary -->
    <VApp :style="`--v-global-theme-primary: ${hexToRgb(global.current.value.colors.primary)}`">
      <RouterView />
      <GlobalSnackbar
        v-model="snackbarStore.showSnackbar"
      />
    </VApp>
  </VLocaleProvider>
</template>
